module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag14_0636AT.19231aa3.jpg";